/* src/app/components/login-card/login-card.component.scss */
ion-card-title {
  font-family: "League Spartan", sans-serif;
}
p {
  font-family: "Barlow Semi Condensed", sans-serif;
}
.login-button {
  text-align: center;
}
.login-button ion-button {
  --padding-start: 20px !important;
  --padding-end: 20px !important;
}
.login-button ion-button ion-icon {
  padding-right: 4px;
}
ion-card {
  margin: 0;
}
p {
  margin-bottom: 20px;
}
ion-row {
  column-gap: 20px;
}
ion-row ion-button {
  width: 150px;
}
ion-card-title {
  font-size: 40px;
  line-height: 40px;
}
ion-card-content p {
  font-size: 22px;
  line-height: 22px;
  font-family: "Barlow Semi Condensed", sans-serif;
}
ion-card-content strong {
  font-size: 18px;
  line-height: 18px;
}
ion-card-content ion-button span {
  margin-top: 4px;
}
.text-center {
  text-align: center;
}
/*# sourceMappingURL=login-card.component-B52HK2QJ.css.map */
